import { useEffect, useState } from 'react';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from '../firebase';

// Fetch + activate once per session; subsequent hook mounts reuse it.
let activatePromise = null;
const ensureActivated = () => {
    if (!remoteConfig) {
        console.log('[RemoteConfig] not available (unsupported env) — using defaults');
        return Promise.resolve();
    }
    if (!activatePromise) {
        activatePromise = fetchAndActivate(remoteConfig)
            .then((activated) => activated)
            .catch(() => {});
    }
    return activatePromise;
};

// Read + parse the `featureFlags` JSON param. Falls back to the SDK default
// ({"referral": false}) — returned immediately even before a fetch resolves.
export const readFeatureFlags = () => {
    if (!remoteConfig) return { referral: false, multiBooking: false };
    try {
        return JSON.parse(getValue(remoteConfig, 'featureFlags').asString() || '{}');
    } catch {
        return {};
    }
};

// All feature flags + a `ready` flag (true once the remote fetch has activated).
// `flags` starts from the SDK default and updates after the fetch resolves.
export const useFeatureFlags = () => {
    const [state, setState] = useState(() => ({ flags: readFeatureFlags(), ready: false }));
    useEffect(() => {
        let mounted = true;
        ensureActivated().then(() => { if (mounted) setState({ flags: readFeatureFlags(), ready: true }); });
        return () => { mounted = false; };
    }, []);
    return state;
};

// Convenience: boolean for a single flag, e.g. useFeatureFlag('referral').
export const useFeatureFlag = (name) => !!useFeatureFlags().flags[name];
